import { ScrollView } from "../ScrollView.js";
import { IScrollViewWheel } from "./IScrollViewWheel.js";

export class ScrollViewWheelZoom implements IScrollViewWheel {
    public apply(view: ScrollView, deltaY: number, event: WheelEvent): void {
        var scale = view.scaleTarget;
        var wheelZoomFactor = 1.5;
        if (deltaY < 0)
            scale *= wheelZoomFactor;
        else
            scale *= 1 / wheelZoomFactor;
        view.scaleAtGlobal(scale, event.clientX, event.clientY, 0.3);
    }
}